'use strict';

module.exports = {
    ENDPOINT: 'ENDPOINT',
    STORAGE_PROFILE: 'STORAGE_PROFILE',
    USER: 'USER',
    CHANGE_PASSWORD_REQUEST: 'CHANGE_PASSWORD_REQUEST',
    CONNECTION_TEST: 'CONNECTION_TEST',
    PLATFORM_OTP: 'PLATFORM_OTP',
    MFA_TOKEN: 'MFA_TOKEN'
};